import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./pc_style.less?vue&type=style&index=0&id=6e6253ac&lang=less&scoped=true"
import "./mobile_style.less?vue&type=style&index=1&id=6e6253ac&lang=less&scoped=true"
import "./styles/shared.less?vue&type=style&index=2&lang=less"
import "./styles/loading.less?vue&type=style&index=3&lang=less"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e6253ac"]])

export default __exports__